<div class="generic-confirm-modal">
  <div class="generic-confirm-modal__header acknowledgement-header">
    <h3 class="modal-title" data-testid="acknowledgement-title">One last step!</h3>
    <button
      type="button"
      class="acknowledgement-close"
      aria-label="Close"
      data-testid="acknowledgement-close"
      (click)="cancelClick()"
    >
      &times;
    </button>
  </div>
  <div class="generic-confirm-modal__body">
    <p data-testid="acknowledgement-message">
      Please acknowledge that you have read and signed all required documents.
    </p>
  </div>
  <div class="generic-confirm-modal__footer">
    <app-button-container>
      <app-button
        type="secondary"
        [dataTestId]="'acknowledgement-cancel'"
        (buttonClick)="cancelClick()"
      >
        Cancel
      </app-button>
      <app-button
        type="primary"
        [dataTestId]="'acknowledgement-confirm'"
        (buttonClick)="acknowledgeClick()"
      >
        Acknowledge
      </app-button>
    </app-button-container>
  </div>
</div>
